import FptContainer from "../fpt/fptContainer";
import { prepareRepeatTrasladoValues } from "../formRepeatUtils";
import FptTraslados from "./fptTraslados";
import {
  getFormFieldOptions,
  getIdEstadoInicialTraslados,
  prepareFptTrasladosValues,
  transformFptTrasladosSubmitValues,
} from "./fptTrasladosUtils";

const resolveModalidades = (fields) =>
  getFormFieldOptions(fields, "idModalidad", "IdModalidad");

const FptTrasladosContainer = ({ isRepeatForm = false, ...props }) => (
  <FptContainer
    {...props}
    FormComponent={FptTraslados}
    isRepeatForm={isRepeatForm}
    prepareFormValues={(values, fields) => {
      const idEstadoInicial = getIdEstadoInicialTraslados(fields);
      const prepared = prepareFptTrasladosValues(
        values,
        resolveModalidades(fields),
        idEstadoInicial,
      );
      return isRepeatForm ? prepareRepeatTrasladoValues(prepared) : prepared;
    }}
    transformSubmitValues={(values, fields) =>
      transformFptTrasladosSubmitValues(
        values,
        resolveModalidades(fields),
        getIdEstadoInicialTraslados(fields),
      )
    }
  />
);

export default FptTrasladosContainer;
